import {
  DOCUMENT_ALL, DOCUMENT_GET, DOCUMENT_PUT, DOCUMENT_DEL, DOCUMENT_POST,
  DOCUMENT_RESET, DOCUMENT_LOADING, DOCUMENT_ERROR,
} from '../../actions/types';

const initialState = {
  rows: [],
  total: 0,
  current: null,  // เก็บ document เดี่ยวแยกจาก list
  isLoading: false,
  isCompleted: true,
};

export default function DocumentReducer(state = initialState, action) {
  switch (action.type) {
    case DOCUMENT_ALL:
      return {
        ...state,
        rows: action.payload.rows || [],
        total: action.payload.total || 0,
        isLoading: false,
        isCompleted: true,
      };
    case DOCUMENT_GET:
      // เก็บลงใน current แทนการ spread ทับ rows/total
      return { ...state, current: action.payload, isLoading: false, isCompleted: true };
    case DOCUMENT_POST:
    case DOCUMENT_PUT:
    case DOCUMENT_DEL:
      return { ...state, isLoading: false, isCompleted: true };
    case DOCUMENT_RESET:
      return { ...initialState };
    case DOCUMENT_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case DOCUMENT_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
